export const toI18nLanguageTag = (languageCode: string) => {
  const [main, region] = languageCode.replace(/_/g, '-').split('-')

  return region
    ? `${main.toLowerCase()}-${region.toUpperCase()}`
    : main.toLowerCase()
}
